import includes from 'lodash/includes'

import type { Store } from '@Globals/Metadata'

/** The Gotham subset a store's alphabet needs; the files live under /static/fonts/<name>/. */
export const selectFont = (store: Pick<Store, 'config'> | undefined): string => {
  const extendedLatinCountries = ['PL', 'CZ', 'SK', 'HU', 'RO', 'HR', 'EE', 'SI', 'LT', 'LV']

  const countryCode = store?.config?.countryCode
  if (includes(extendedLatinCountries, countryCode)) {
    return 'gotham-latin-extended'
  }
  if (countryCode === 'GR' || countryCode === 'CY') {
    return 'gotham-greek'
  }
  if (countryCode === 'BG') {
    return 'gotham-cyrillic'
  }
  return 'gotham-basic'
}
